import type { CheckoutConfig } from '#types/config/components/checkout'
import type { RecursivePartial } from '#types/utils'

export default {
  showStickyPlaceOrderCta: true,
  showStickySaveAndContinueCta: true
} satisfies RecursivePartial<CheckoutConfig['shippingAndDelivery']>
